import React from 'react';

export const LOGIN_LABELS = {
	SECTION_TITLE: 'Login Method',
	LOGIN_URL_LABEL: 'Login URL',
	LOGIN_URL_PLACEHOLDER: 'Enter login URL',
	USER_NAME_LABEL: 'User Name',
	USER_NAME_PLACEHOLDER: 'Enter user name',
	USER_NAME_SELECTOR_LABEL: 'User Name Selector',
	USER_NAME_SELECTOR_PLACEHOLDER: 'Enter user name CSS selector',
	USER_NAME_SELECTOR_TOOLTIP:
		'It is strongly recommended to use an id or a classname. For e.g: #userNameInputBox or .userNameInputBox',
	PASSWORD_LABEL: 'Password',
	PASSWORD_PLACEHOLDER: 'Enter password',
	PASSWORD_SELECTOR_LABEL: 'Password Selector',
	PASSWORD_SELECTOR_PLACEHOLDER: 'Enter password CSS selector',
	PASSWORD_SELECTOR_TOOLTIP:
		'It is strongly recommended to use an id or a classname. For e.g: #passwordInputBox or .passwordInputBox',
	LOGIN_BUTTON_SELECTOR_LABEL: 'Login Button Selector',
	LOGIN_BUTTON_SELECTOR_PLACEHOLDER: 'Enter login button CSS selector',
	COOKIES_CONSENT_LABEL: 'Cookies Consent Button Selector',
	COOKIES_CONSENT_PLACEHOLDER: 'Enter cookies consent button CSS selector',
	COOKIES_CONSENT_TOOLTIP_TITLE: 'Cookies consent button selector',
	COOKIES_CONSENT_TOOLTIP:
		"Please enter the CSS selector for the 'Accept' button in this field. Example: '#cookies-accept-button'",
	COOKIES_LABEL: 'Cookies',
	COOKIES_ARIA_LABEL: 'cookies',
	COOKIES_PLACEHOLDER: 'Enter cookies',
	INVALID_COOKIE_ERROR: `Cookies are of incorrect format.
            Cookies are expected to be a valid json list where each entry is a valid puppeteer cookie:
            https://pptr.dev/#?product=Puppeteer&version=v10.0.0&show=api-pagesetcookiecookies`,
	NO_LOGIN_REQUIRED: 'No login required',
	FORM_LOGIN: 'Form login',
	LOGIN_WITH_COOKIES: 'Login with cookies',
	SELECT_PLACEHOLDER: 'Select Login Method',
	SELECT_LABEL: 'Login Method',
	LEGACY_CONFIG_WARNING:
		'Multiple interactions are already set for this property. Contact support for assistance.'
} as const;

export const LOGIN_MORE_INFO = (
	<>
		Choosing and setting up a login method will perform a login using the selected method, and
		allows scanning and crawling behind login pages.
	</>
);
